import React, { useState } from 'react';
import {
  Paper,
  Button,
  Divider,
  FormControl,
  Box,
  Link,
  IconButton,
  InputAdornment,
  Typography,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import BusinessIcon from '@mui/icons-material/Business';
import StorefrontIcon from '@mui/icons-material/Storefront';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";
import { pt } from 'yup-locale-pt';
import {
  useNavigate,
  useLocation,
} from "react-router-dom";
import { TextField } from '../../components';
import api from "../../services/api";
import { useStoreActions } from 'easy-peasy';
yup.setLocale(pt);

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);
  let setUser = useStoreActions((actions) => actions.auth.setUser);

  let navigate = useNavigate();
  let location = useLocation();

  let from = location.state?.from?.pathname || "/";

  const schema = yup.object({
    email: yup.string().email().label('Email').required(),
    password: yup.string().label('Senha').required(),
    manterConectado: yup.boolean(),
  }).required();

  const useFormRef = useForm({
    mode: 'onTouched',
    resolver: yupResolver(schema),
    defaultValues: { manterConectado: true },
  });

  const { handleSubmit, register,
          formState: {isDirty,isSubmitting} } = useFormRef;

  const onSubmit = async (data) => {
    startLoading();
    try {
      await api.signin(data);
      setUser((await api.http.get('auth-user')).data);
      stopLoading({ severity: 'success' });
      navigate(from == '/' ? '/processos' : from, { replace: true });
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };

  return (
    <Paper variant="outlined" className='center-box' sx={{
      textAlign: 'center',
      px: 4,
      pt: 2,
      pb: 3,
      m: 5,
      maxWidth: 'sm',
    }}>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Divider>
          <h3>Login</h3>
        </Divider>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField
            field="email"
            type="email"
            useFormRef={useFormRef}
            schema={schema}
            InputLabelProps={{ shrink: true }}
          />
        </FormControl>
        <FormControl sx={{ my: 2 }} fullWidth>
          <TextField
            field="password"
            type={showPassword ? 'text' : 'password'}
            useFormRef={useFormRef}
            schema={schema}
            InputLabelProps={{ shrink: true }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </FormControl>
        <FormControlLabel
          control={<Checkbox defaultChecked {...register('manterConectado')} />}
          label="Manter conectado neste navegador"
          sx={{ display: 'flex', mb: 1 }}
        />
        <Link href="/esqueci-minha-senha">Esqueci minha senha</Link>
        <Box sx={{ mt: 3 }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            endIcon={<ArrowForwardIcon />}
            disabled={!isDirty || isSubmitting}
            sx={{
              py: 1.5,
              px: 3,
              fontSize: '1rem',
              fontWeight: 600,
              textTransform: 'none',
              letterSpacing: '0.02em',
              boxShadow: 2,
              borderRadius: 2,
              '&:hover': {
                boxShadow: 4,
                transform: 'translateY(-1px)',
              },
              '&:active': {
                transform: 'translateY(0)',
              },
              transition: 'all 0.2s ease-in-out',
            }}
          >
            Acessar o sistema
          </Button>
        </Box>
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'block', mt: 2 }}
        >
          v1.0.1
        </Typography>
      </form>

      {/* Quem ainda não tem usuário: inscrição da empresa (checa o CNPJ e segue pro
          cadastro) ou credenciamento de fornecedor */}
      <Divider sx={{ mt: 4, mb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Ainda não tem acesso?
        </Typography>
      </Divider>
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2 }}>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<BusinessIcon />}
          onClick={() => navigate('/interesse')}
          sx={{ py: 1.25, textTransform: 'none', borderRadius: 2 }}
        >
          Quero inscrever minha empresa
        </Button>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<StorefrontIcon />}
          onClick={() => navigate('/inscfornecedor')}
          sx={{ py: 1.25, textTransform: 'none', borderRadius: 2 }}
        >
          Quero me cadastrar como fornecedor
        </Button>
      </Box>
    </Paper>
  );
};

export default Login;
